module.exports = __webpack_public_path__ + "img/mongoDB-mysql.8cac8230.png";